import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import {
	CheckboxGroup,
	ToggleSwitch,
	FormCheckConditional,
} from '../../../../components/forms';
import Utils from '../../../../common/utils';
import AviationQuestions from './activitiesSubQuestions/AviationQuestions';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const ActivitiesQuestion: React.StatelessComponent<Props> = props => {
	const questionName = 'activities';
	const onChange = (e: any) => {
		if (e.target.type === 'text' && !e.target.validity.valid) {
			return;
		}

		const customEvent = createCustomQuestionEvent(e);
		props.onQuestionnaireChange(customEvent);
	};
	const onBlur = (e: any) => {
		const customEvent = createCustomQuestionEvent(e);
		props.onQuestionnaireBlur(customEvent);
	};
	const createCustomQuestionEvent = (e: any) => {
		const value = Utils.parseValueFromEvent(e);

		let answer = {
			...props.questionnaire[questionName],
			[e.target.name]: value
		};

		if (e.target.name === 'activitiesNoneOfTheAbove' && value) {
			// user clicked none option, remove all other values
			answer = {
				[e.target.name]: value
			};
		}
		else {
			answer.activitiesNoneOfTheAbove = false;

			handleSubQuestions(e.target.name, answer);
		}

		const questionnaireEvent = {
			target: {
				name: questionName,
				value: answer,
				type: 'custom',
			}
		};

		return questionnaireEvent;
	};
	const handleSubQuestions = (name: string, answer: any) => {
		if (name === 'aviation' && answer[name] !== true) {
			delete answer.aviationLicense;
			delete answer.aviationInstrumentRating;
			delete answer.aviationHoursExperience;
			delete answer.aviationHoursAnnually;
			delete answer.aviationAccidents;
		}
		else if (name === 'hangGliding' && answer[name] !== true) {
			delete answer.hangGlidingStunt;
		}
		else if (name === 'ultralightFlying' && answer[name] !== true) {
			delete answer.ultralightFlyingStunts;
		}
		else if (name === 'backcountrySkiing' && answer[name] !== true) {
			delete answer.heliSkiSnowboarding;
			delete answer.outOfBoundsSkiingSnowboarding;
			delete answer.backCountrySnowMobiling;
		}
		else if (name === 'mountainClimbing' && answer[name] !== true) {
			delete answer.mountainClimbingTall;
		}
		else if (name === 'skydivingActivities' && answer[name] !== true) {
			delete answer.skydiving;
			delete answer.skydivingOneTime;
			delete answer.wingsuitFlying;
			delete answer.parachuting;
			delete answer.parachutingOneTime;
			delete answer.skysurfing;
			delete answer.canopyPiloting;
			delete answer.skydivingExtreme;
		}
		else if (name === 'skydiving' && answer[name] !== true) {
			delete answer.skydivingOneTime;
		}
		else if (name === 'parachuting' && answer[name] !== true) {
			delete answer.parachutingOneTime;
		}
		else if (name === 'bungeeJumping' && answer[name] !== true) {
			delete answer.bungeeJumpingOneTime;
		}
	};

	const isNextDisabled = function () {
		var valid =
			(props.questionnaire[questionName].aviation === true
				|| props.questionnaire[questionName].hangGliding === true
				|| props.questionnaire[questionName].ultralightFlying === true
				|| props.questionnaire[questionName].scubaDiving === true
				|| props.questionnaire[questionName].backcountrySkiing === true
				|| props.questionnaire[questionName].mountainClimbing === true
				|| props.questionnaire[questionName].skydivingActivities === true
				|| props.questionnaire[questionName].mountainClimbing === true
				|| props.questionnaire[questionName].motorizedRacing === true
				|| props.questionnaire[questionName].bungeeJumping === true
				|| props.questionnaire[questionName].fightSports === true
				|| props.questionnaire[questionName].activitiesNoneOfTheAbove === true
			);
		if (props.questionnaire[questionName].aviation === true) {
			if (props.questionnaire[questionName].aviationLicense === undefined ||
				props.questionnaire[questionName].aviationInstrumentRating === undefined ||
				!props.questionnaire[questionName].aviationHoursExperience ||
				!props.questionnaire[questionName].aviationHoursAnnually ||
				props.questionnaire[questionName].aviationAccidents === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire[questionName].hangGliding === true) {
			if (props.questionnaire[questionName].hangGlidingStunt === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire[questionName].ultralightFlying === true) {
			if (props.questionnaire[questionName].ultralightFlyingStunts === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire[questionName].mountainClimbing === true) {
			if (props.questionnaire[questionName].mountainClimbingTall === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire[questionName].skydivingActivities === true) {
			if (props.questionnaire[questionName].skydiving === true) {
				if (props.questionnaire[questionName].skydivingOneTime === undefined) {
					valid = false;
				}
			}
			if (props.questionnaire[questionName].parachuting === true) {
				if (props.questionnaire[questionName].parachutingOneTime === undefined) {
					valid = false;
				}
			}
			if (props.questionnaire[questionName].skydivingExtreme === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire[questionName].bungeeJumping === true) {
			if (props.questionnaire[questionName].bungeeJumpingOneTime === undefined) {
				valid = false;
			}
		}
		return !valid;
	};

	if (props.questionnaire[questionName] === undefined) {
		props.questionnaire[questionName] = {};
	}
	return (
		<div>
			<CheckboxGroup
				title={props.questions.activities}
				checkOptions={[
					{
						name: 'aviation',
						label: props.questions.aviation,
						checked: props.questionnaire[questionName].aviation,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<AviationQuestions
								questionnaire={props.questionnaire}
								questions={props.questions}
								onBlur={onBlur}
								onChange={onChange}
							/>
						)
					},
					{
						name: 'hangGliding',
						label: props.questions.hangGliding,
						checked: props.questionnaire[questionName].hangGliding,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire[questionName].hangGliding}>
								<ToggleSwitch
									labelText={props.questions.hangGlidingStunt}
									className="mb-2 toggle-yes-no"
									name="hangGlidingStunt"
									onChildren="Yes"
									offChildren="No"
									onBlur={onBlur}
									onChange={onChange}
									checked={props.questionnaire[questionName].hangGlidingStunt}
								/>
							</FormCheckConditional>
						)
					},
					{
						name: 'ultralightFlying',
						label: props.questions.ultralightFlying,
						checked: props.questionnaire[questionName].ultralightFlying,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire[questionName].ultralightFlying}>
								<ToggleSwitch
									labelText={props.questions.ultralightFlyingStunts}
									className="mb-2 toggle-yes-no"
									name="ultralightFlyingStunts"
									onChildren="Yes"
									offChildren="No"
									onBlur={onBlur}
									onChange={onChange}
									checked={props.questionnaire[questionName].ultralightFlyingStunts}
								/>
							</FormCheckConditional>
						)
					},
					{
						name: 'scubaDiving',
						label: props.questions.scubaDiving,
						checked: props.questionnaire[questionName].scubaDiving,
						onBlur: onBlur,
						onChange: onChange
					},
					{
						name: 'backcountrySkiing',
						label: props.questions.backcountrySkiing,
						checked: props.questionnaire[questionName].backcountrySkiing,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire[questionName].backcountrySkiing}>
								<CheckboxGroup
									name="backcountrySkiingTypes"
									title={props.questions.backcountrySkiingTypes}
									checkOptions={[
										{
											name: 'heliSkiSnowboarding',
											label: 'Heli-skiing or snowboarding',
											checked: props.questionnaire[questionName].heliSkiSnowboarding,
											onBlur: onBlur,
											onChange: onChange
										},
										{
											name: 'outOfBoundsSkiingSnowboarding',
											label: 'Out-of-bounds or backcountry skiing or snowboarding',
											checked: props.questionnaire[questionName].outOfBoundsSkiingSnowboarding,
											onBlur: onBlur,
											onChange: onChange
										},
										{
											name: 'backCountrySnowMobiling',
											label: 'Backcountry snowmobiling',
											checked: props.questionnaire[questionName].backCountrySnowMobiling,
											onBlur: onBlur,
											onChange: onChange
										}
									]}
									className="mb-2"
								/>
							</FormCheckConditional>
						)
					},
					{
						name: 'mountainClimbing',
						label: props.questions.mountainClimbing,
						checked: props.questionnaire[questionName].mountainClimbing,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire[questionName].mountainClimbing}>
								<ToggleSwitch
									labelText={props.questions.mountainClimbingTall}
									className="mb-2 toggle-yes-no"
									name="mountainClimbingTall"
									onChildren="Yes"
									offChildren="No"
									onBlur={onBlur}
									onChange={onChange}
									checked={props.questionnaire[questionName].mountainClimbingTall}
								/>
							</FormCheckConditional>
						)
					},
					{
						name: 'skydivingActivities',
						label: props.questions.skydivingActivities,
						checked: props.questionnaire[questionName].skydivingActivities,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire[questionName].skydivingActivities}>
								<CheckboxGroup
									name="skydivingActivitiesTypes"
									title={props.questions.skydivingActivitiesTypes}
									checkOptions={[
										{
											name: 'skydiving',
											label: 'Skydiving',
											checked: props.questionnaire[questionName].skydiving,
											onBlur: onBlur,
											onChange: onChange,
											conditionalChildren: (
												<FormCheckConditional isOpen={props.questionnaire[questionName].skydiving}>
													<ToggleSwitch
														labelText={props.questions.skydivingOneTime}
														className="mb-2 toggle-yes-no"
														name="skydivingOneTime"
														onChildren="Yes"
														offChildren="No"
														onBlur={onBlur}
														onChange={onChange}
														checked={props.questionnaire[questionName].skydivingOneTime}
													/>
												</FormCheckConditional>
											)
										},
										{
											name: 'wingsuitFlying',
											label: 'Wingsuit flying',
											checked: props.questionnaire[questionName].wingsuitFlying,
											onBlur: onBlur,
											onChange: onChange
										},
										{
											name: 'parachuting',
											label: 'Parachuting',
											checked: props.questionnaire[questionName].parachuting,
											onBlur: onBlur,
											onChange: onChange,
											conditionalChildren: (
												<FormCheckConditional isOpen={props.questionnaire[questionName].parachuting}>
													<ToggleSwitch
														labelText={props.questions.parachutingOneTime}
														className="mb-2 toggle-yes-no"
														name="parachutingOneTime"
														onChildren="Yes"
														offChildren="No"
														onBlur={onBlur}
														onChange={onChange}
														checked={props.questionnaire[questionName].parachutingOneTime}
													/>
												</FormCheckConditional>
											)
										},
										{
											name: 'skysurfing',
											label: 'Skysurfing',
											checked: props.questionnaire[questionName].skysurfing,
											onBlur: onBlur,
											onChange: onChange
										},
										{
											name: 'canopyPiloting',
											label: 'Canopy piloting',
											checked: props.questionnaire[questionName].canopyPiloting,
											onBlur: onBlur,
											onChange: onChange
										}
									]}
								/>
								<ToggleSwitch
									labelText={props.questions.skydivingExtreme}
									className="mb-2 toggle-yes-no"
									name="skydivingExtreme"
									onChildren="Yes"
									offChildren="No"
									onBlur={onBlur}
									onChange={onChange}
									checked={props.questionnaire[questionName].skydivingExtreme}
								/>
							</FormCheckConditional>
						)
					},
					{
						name: 'motorizedRacing',
						label: props.questions.motorizedRacing,
						checked: props.questionnaire[questionName].motorizedRacing,
						onBlur: onBlur,
						onChange: onChange
					},
					{
						name: 'bungeeJumping',
						label: props.questions.bungeeJumping,
						checked: props.questionnaire[questionName].bungeeJumping,
						onBlur: onBlur,
						onChange: onChange,
						conditionalChildren: (
							<FormCheckConditional isOpen={props.questionnaire[questionName].bungeeJumping}>
								<ToggleSwitch
									labelText={props.questions.bungeeJumpingOneTime}
									className="mb-2 toggle-yes-no"
									name="bungeeJumpingOneTime"
									onChildren="Yes"
									offChildren="No"
									onBlur={onBlur}
									onChange={onChange}
									checked={props.questionnaire[questionName].bungeeJumpingOneTime}
								/>
							</FormCheckConditional>
						)
					},
					{
						name: 'fightSports',
						label: props.questions.fightSports,
						checked: props.questionnaire[questionName].fightSports,
						onBlur: onBlur,
						onChange: onChange
					},
					{
						name: 'activitiesNoneOfTheAbove',
						label: 'None of the above',
						checked: props.questionnaire[questionName].activitiesNoneOfTheAbove,
						onBlur: onBlur,
						onChange: onChange,
						className: 'border-top pt-2'
					}
				]}
			/>

			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default ActivitiesQuestion;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/activitiesQuestions/ActivitiesQuestion.tsx